<template>
    <div>
        <md-field>
            <tree :setting="setting" :nodes="treeData" ref="tree" class="md-tree" />
        </md-field>
        <v-select v-model="form.templateId" :items="actionMap[form.structId]" item-text="name" item-value="id" label="动作"></v-select>
        <v-text-field v-model="form.defaultValue" label="录入值" v-if="variableType === 'string'"></v-text-field>
        <v-text-field v-model="form.defaultValue" label="录入值" v-if="variableType === 'int' || variableType === 'float'"></v-text-field>
        <v-select v-model="form.defaultValue" :items="form.ranges" label="录入值" v-if="variableType === 'enum'" :rules="[v => !!v || '录入值不能为空']"></v-select>
        <!-- 系统内置行为表单 -->
        <v-select v-model="form.moveModel" :items="moveModel_list" item-text="name" item-value="value" label="移动模式*" :rules="[v => !!v || '移动模式不能为空']" v-if="variableType === 'move'"></v-select>
        <div class="md-layout" v-if="variableType === 'move'">
            <div class="md-layout-item md-size-15" style="padding-top: 20px">
                <label class="md-form-label-ext"> 移动坐标 * </label>
            </div>
            <div class="md-layout-item md-size-30">
                <v-text-field v-model="form.movezbx" label="X" :rules="[v => !!v || '坐标X不能为空']"></v-text-field>
            </div>
            <div class="md-layout-item md-size-30">
                <v-text-field v-model="form.movezby" label="Y" :rules="[v => !!v || '坐标Y不能为空']"></v-text-field>
            </div>
            <div class="md-layout-item md-size-25">
                <v-text-field v-model="form.movezbz" label="Z" :rules="[v => !!v || '坐标Z不能为空']"></v-text-field>
            </div>
        </div>
        <v-text-field v-model="form.moveTime" label="移动时间(秒) *" v-if="variableType === 'move'"></v-text-field>
        <div class="md-layout" v-if="variableType === 'rotate'">
            <div class="md-layout-item md-size-15" style="padding-top: 20px">
                <label class="md-form-label-ext"> 旋转坐标 * </label>
            </div>
            <div class="md-layout-item md-size-30">
                <v-text-field v-model="form.rotatex" label="X"></v-text-field>
            </div>
            <div class="md-layout-item md-size-30">
                <v-text-field v-model="form.rotatey" label="Y"></v-text-field>
            </div>
            <div class="md-layout-item md-size-25">
                <v-text-field v-model="form.rotatez" label="Z"></v-text-field>
            </div>
        </div>
        <v-text-field v-model="form.rotateTime" label="旋转时间(秒) *" v-if="variableType === 'Rotate'"></v-text-field>
        <v-text-field v-model="form.animateResource" label="动画资源 *" v-if="variableType === 'PlayAnimation'"></v-text-field>
        <v-text-field v-model="form.animateSpeed" label="播放速率(帧/秒) *" v-if="variableType === 'PlayAnimation'"></v-text-field>
        <md-field v-if="variableType === 'PlayAnimation'">
            <div class="md-layout">
                <div class="md-layout-item md-size-20">
                    <label style="padding-top: 5px">是否倒播</label>
                </div>
                <div class="md-layout-item md-size-75">
                    <v-switch v-model="form.replay"></v-switch>
                </div>
            </div>
        </md-field>
        <v-radio-group v-model="form.type">
            <v-radio label="动态参数：允许在任务中进行动态设置" value="dynamic"></v-radio>
            <v-radio label="静态参数：固定在当前定义的动作内部" value="static"></v-radio>
        </v-radio-group>
        <div v-if="variableType === 'bool'">
            <label style="margin-right: 15px">录入值</label>
            <v-radio-group v-model="form.defaultValue">
                <v-radio label="true" value="true"></v-radio>
                <v-radio label="false" value="false"></v-radio>
            </v-radio-group>
        </div>
    </div>
</template>
<script>
import tree from "vue-giant-tree";
import { findTypeListBySceneId } from "@/api/device";
import { innerAction } from "../../SystemAction";
let ztreeObj = {}
export default {
    props: {
        treeData: {
            type: Array,
            default: () => [],
        },
    },
    inject: ["taskInfo"],
    components: {
        tree,
    },
    computed: {
        variableType() {
            const structId = this.form.structId;
            let actionIndex = 0;
            const action = this.actionMap[structId];
            if (!action) {
                return "";
            }

            actionIndex = action.findIndex(
                (item) => item.id === this.form.templateId
            );
            this.form.templateName = action[actionIndex].name;
            this.form.actionData = action[actionIndex]
            this.form.typeId = action[actionIndex]._id

            if (action[actionIndex] && action[actionIndex].type === 'system_inner') {
                return action[actionIndex].template
            }

      const extId = this.actionMap[structId][actionIndex].extendedPropertiesId;
      if (this.extendedPropertiesMap[structId]) {
        const extObj = this.extendedPropertiesMap[structId][extId] ?? {};
        this.form.defaultValue = (extObj.default_value && extObj.default_value !== false) ?? false;
        this.$nextTick(() => {
          this.$forceUpdate()
        })
        return extObj.variable_type;
      }
      return "";
    },
  },
  data() {
    return {
      moveModel_list: [
        { value: 'sy', name: '瞬移' },
        { value: 'py', name: '平移' },
        { value: 'xj', name: '寻径' }
      ],
      template_list: [
        { value: 'hide', name: '隐藏' },
        { value: 'display', name: '显示' },
        { value: 'move', name: '移动' },
        { value: 'rotate', name: '旋转' },
        { value: 'scale', name: '缩放' },
        { value: 'highlight', name: '高亮' },
        { value: 'dishighlight', name: '取消高亮' },
        { value: 'animation', name: '播放动画' }
      ],
      form: {
        defaultValue: false
      },
      setting: {
        check: {
          //树是否带复选框或者单选框
          enable: false,
        },
        data: {
          simpleData: {
            //是否使用简单数据模式
            enable: true,
            //树节点id，一般是后台数据库主键
            idKey: "id",
            //父级id
            pIdKey: "pid",
            rootPId: "0",
          },
        },
        //ztree回调函数
        callback: {
          //树选择事件
          onClick: this.treeNodeClick,
        },
      },
      list: [],
      actionMap: {},
      extendedPropertiesMap: {},
      dataMap: {},
    };
  },
  mounted() {
    this.getList();
    console.log(this.taskInfo, '数据查询')
  },
  methods: {
    init(form) {
      this.form = form;
      this.$forceUpdate(); if (this.form.structId) {
        let uuuid = this.form.structId
        let nodes = ztreeObj.getNodes()
        let setModel = (l) => {
          l.forEach((v) => {
            if (v.id === uuuid) {
              let tId = v.tId

              ztreeObj.refresh()

              let nodeList = ztreeObj.getNodesByParam('id', uuuid) //模糊搜索
              if (nodeList[0]) {
                let parentList = ztreeObj.getNodesByParam('id', nodeList[0].pid)
                if (parentList[0]) {
                  ztreeObj.expandNode(parentList[0], true, false, false)
                }
              }
              this.$nextTick(() => {
                let dom = document.getElementById(tId + '_a')
                if (dom) {
                  dom.click()
                }
              })
            }
            if (v.children && v.children.length !== 0) {
              setModel(v.children)
            }
          })
        }
        setModel(nodes)
      }
    },
    handleCreated(obj) {
      ztreeObj = obj;
    },
    data() {
        return {
            moveModel_list: [
                { value: 'sy', name: '瞬移' },
                { value: 'py', name: '平移' },
                { value: 'xj', name: '寻径' }
            ],
            template_list: [
                { value: 'hide', name: '隐藏' },
                { value: 'display', name: '显示' },
                { value: 'move', name: '移动' },
                { value: 'rotate', name: '旋转' },
                { value: 'scale', name: '缩放' },
                { value: 'highlight', name: '高亮' },
                { value: 'dishighlight', name: '取消高亮' },
                { value: 'animation', name: '播放动画' }
            ],
            form: {
                defaultValue: false
            },
            setting: {
                check: {
                    //树是否带复选框或者单选框
                    enable: false,
                },
                data: {
                    simpleData: {
                        //是否使用简单数据模式
                        enable: true,
                        //树节点id，一般是后台数据库主键
                        idKey: "id",
                        //父级id
                        pIdKey: "pid",
                        rootPId: "0",
                    },
                },
                //ztree回调函数
                callback: {
                    //树选择事件
                    onClick: this.treeNodeClick,
                },
            },
            list: [],
            actionMap: {},
            extendedPropertiesMap: {},
            dataMap: {},
        };
    },
    mounted() {
        this.getList();
        console.log(this.taskInfo, '数据查询')
    },
    getList() {
      findTypeListBySceneId({ sceneId: this.taskInfo.taskInfo.device, type: 'device' }).then((res) => {
        this.list = res.data;
        this.actionMap = res.data.reduce((pre, next) => {
          pre[next.structId] = next.deviceTypeInfo ?
            next.deviceTypeInfo.actions : [];

                    pre[next.structId] = pre[next.structId].map(item => {
                        item._id = next.deviceTypeInfo._id
                        return item
                    })

                    pre[next.structId] = pre[next.structId].concat(
                        innerAction.flatMap(item => item.action_list).map(item => {
                            item.type = 'system_inner'
                            return item
                        })
                    )
                    return pre;
                }, {});

        this.extendedPropertiesMap = res.data.reduce((pre, next) => {
          if (next.deviceTypeInfo) {
            pre[next.structId] = next.deviceTypeInfo.extended_properties.reduce(
              (epPre, epNext) => {
                epPre[epNext.id] = epNext;
                return epPre;
              }, {}
            );
          }
          return pre;
        }, {});

                this.dataMap = res.data.reduce((pre, next) => {
                    pre[next.structId] = next;
                    return pre;
                }, {});
            });
        },
    },
};
</script>
<style>
.md-tree {
    padding: 15px 15px;
}
</style>